import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styles from '../../../css/Dashboards/DevicesUseTimeChart.module.css'
import { secondsToString } from '../../generals/charts/utils/DatesFormats'
import { useTranslation } from 'react-i18next'
export default function DevicesUseTimeChart ({ data, filter }) {
  const [time, setTime] = useState()

  const { t } = useTranslation('home')

  const useTimes = [
    {

      label: t('boxChart5.label1'),
      backgroundColor: '#4A499B'
    },
    {
      label: t('boxChart5.label2'),
      backgroundColor: '#1E4D66'

    },
    {
      label: t('boxChart5.label3'),
      backgroundColor: '#5EA2C7'
    },
    {
      label: t('boxChart5.label4'),
      backgroundColor: '#1B1B1B'
    }
  ]

  useEffect(() => {
    if (data) {
      const uniqueDeviceIds = new Set(data?.devicesUseTime?.map(item => item.deviceId))
      const devices = uniqueDeviceIds.size
      const seconds = data?.useTime / devices
      const secondsWithFilter = seconds / (filter === 0 ? 1 : filter)
      let time = secondsToString(secondsWithFilter)
      time = time.split(':')
      time = Math.round(Number(time[0])) + 'H ' + Math.round(Number(time[1])) + 'M ' + Math.round(Number(time[2])) + 'S'
      setTime(time)
    }
  }, [data])

  if (data?.devicesUseTime.length > 0) {
    return (
        <div className={styles.container}>
          <div className={styles.containerLabels}>
            <p className={styles.time}>{time}</p>
            <p>{data.useTime >= 28800 ? useTimes[0].label : data.useTime >= 14400 && data.useTime < 28800 ? useTimes[1].label : data.useTime > 0 && data.useTime < 14400 ? useTimes[2].label : useTimes[3].label}</p>
          </div>
          <div className={styles.bar} style={{ backgroundColor: `${data.useTime >= 28800 ? useTimes[0].backgroundColor : data.useTime >= 14400 && data.useTime < 28800 ? useTimes[1].backgroundColor : data.useTime > 0 && data.useTime < 14400 ? useTimes[2].backgroundColor : useTimes[3].backgroundColor}` }}></div>
          <div className={styles.legend}>
            <div className={styles.label} key={` ${useTimes[0].label}_p`}>
              <div className={styles.colorRef} key={` ${useTimes[0].label}_div`} style={{ backgroundColor: `${useTimes[0].backgroundColor}` }}></div>
              <p>{` ${useTimes[0].label}`}</p>
            </div>
            <div className={styles.label} key={` ${useTimes[1].label}_p`}>
              <div className={styles.colorRef} key={` ${useTimes[1].label}_div`} style={{ backgroundColor: `${useTimes[1].backgroundColor}` }}></div>
              <p>{` ${useTimes[1].label}`}</p>
            </div>
            <div className={styles.label} key={` ${useTimes[2].label}_p`}>
              <div className={styles.colorRef} key={` ${useTimes[2].label}_div`} style={{ backgroundColor: `${useTimes[2].backgroundColor}` }}></div>
              <p>{` ${useTimes[2].label}`}</p>
            </div>
            <div className={styles.label} key={` ${useTimes[3].label}_p`}>
              <div className={styles.colorRef} key={` ${useTimes[3].label}_div`} style={{ backgroundColor: `${useTimes[3].backgroundColor}` }}></div>
              <p>{` ${useTimes[3].label}`}</p>
            </div>
          </div>
        </div>
    )
  }
}

DevicesUseTimeChart.propTypes = {
  data: PropTypes.object,
  filter: PropTypes.number
}
